/**
 * JobActivityList
 *
 * Presentational list of currently-running jobs — one row per job: the job
 * label over a live `JobProgressBar`. Used by both the notification dropdown's
 * Activity tab and the notifications page's Activity section. Pass `jobs` (from
 * `useActiveJobs()`); renders `emptyState` (or nothing) when there are none.
 */

import React from 'react';

import { JobProgressUtils } from '@personal-trainer-app/shared';

import type { JobActivityListProps } from './JobActivityList.types';

import { JobProgressBar } from '@/components/ui';

export function JobActivityList({
  jobs,
  emptyState,
  className = '',
}: JobActivityListProps): React.JSX.Element | null {
  if (jobs.length === 0) {
    return emptyState ? <>{emptyState}</> : null;
  }

  return (
    <ul className={className} aria-label="Active background tasks">
      {jobs.map((job) => (
        <li
          key={job.job_id}
          className="border-b border-stroke-subtle px-4 py-3 last:border-b-0"
        >
          <p className="mb-2 truncate text-body-sm font-medium text-neutral-100">
            {JobProgressUtils.getJobLabel(job)}
          </p>
          <JobProgressBar
            progress={job}
            aria-label={JobProgressUtils.getJobLabel(job)}
          />
        </li>
      ))}
    </ul>
  );
}

export default JobActivityList;
